export default __webpack_public_path__ + "static/media/headsetKlein.4a19b05d.jpg";